export enum DoctorMutationKey {
  AuthToken = 'doctor/token',
  AssignExaminations = 'doctor/assignExaminations',
  ExaminationShareLink = 'doctor/examination/shareLink',
}
